import React from "react";
import { graphql } from "gatsby";
import { Link } from "./link";
import Logo from "../icons/logo.svg";
import ArrowRight from "../icons/arrow-right-black.svg";

const Footer = ({ data, generatedLocale, customLogo }) => {
  const {
    footerMenuFiltered: { legalInfo, localeContent },
  } = data;

  return (
    <div className="footer">
      <div className="container-fluid wrapper">
        <div className="row">
          <div className="col-12 order-md-2">
            <div className="footer__border d-flex justify-content-between align-items-center py-3 py-md-4 mt-md-3">
              <div className="d-flex align-items-center pr-3">
                <div className="logo">
                  <Link className="logo__link" to="/" aria-label="Haier">
                    {customLogo ? (
                      <img
                        alt={customLogo?.value?.description || ""}
                        className="icon-svg"
                        src={customLogo.node.publicURL}
                      />
                    ) : (
                      <Logo />
                    )}
                  </Link>
                </div>
                {legalInfo && (
                  <span className="d-none d-md-block ml-3 align-self-end footer__copyright">
                    {legalInfo}
                  </span>
                )}
              </div>
              {localeContent && (
                <div className="footer__language d-inline-flex align-items-center">
                  <img
                    className="footer__flag"
                    src={localeContent.image?.node?.resize?.src}
                    alt={localeContent.image?.value?.description || ""}
                  />
                  <a
                    href={generatedLocale || localeContent.externalLink}
                    className="footer__link d-inline-flex align-items-center"
                    target={localeContent.target || "self"}
                    rel={localeContent.target === "_blank" ? "noopener noreferrer" : ""}
                  >
                    <span className="text-nowrap">{localeContent.liferayFields.title}</span>
                    <ArrowRight className="footer__arrow ml-2" />
                  </a>
                </div>
              )}
            </div>
          </div>
          {legalInfo && (
            <div className="col-12 d-md-none">
              <div className="footer__item py-3">
                <span className="footer__copyright">{legalInfo}</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Footer;
export const query = graphql`
  {
    footerMenuFiltered {
      legalInfo
      localeContent {
        ... on LiferayPageExternalLink {
          liferayFields {
            title
          }
          icon
          image {
            node {
              resize(width: 20, quality: 100) {
                src
              }
            }
            value {
              description
            }
          }
          externalLink
          target
        }
      }
    }
  }
`;
